import type { ReactNode } from "react";

export type SetupStepState = "done" | "current" | "todo";

const dotClasses: Record<SetupStepState, string> = {
  done: "bg-success text-background",
  current: "bg-accent text-surface",
  todo: "bg-muted text-foreground/70",
};

export function SetupStep({
  label,
  state,
  title,
  last = false,
  children,
}: {
  label: string;
  state: SetupStepState;
  title: string;
  last?: boolean;
  children: ReactNode;
}) {
  return (
    <li className="flex gap-4">
      <div className="flex flex-none flex-col items-center">
        <span
          className={`inline-flex size-6 items-center justify-center rounded-full text-xs ${dotClasses[state]}`}
          aria-hidden="true"
        >
          {state === "done" ? "✓" : label}
        </span>
        {last ? null : <span className="my-1 w-0.5 flex-1 bg-muted" />}
      </div>
      <div className={`min-w-0 flex-1 ${last ? "" : "pb-6"}`}>
        <h3
          className={`text-sm font-semibold ${state === "todo" ? "opacity-60" : ""}`}
        >
          {title}
        </h3>
        {children}
      </div>
    </li>
  );
}
